import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../utils/auth';

const AdminNewsEventForm = ({ onItemAdded, editingItem = null }) => {
  const [form, setForm] = useState({
    title: '',
    type: 'News',
    shortDesc: '',
    detailedDesc: '',
    date: '',
    image: null,
  });

  useEffect(() => {
    if (editingItem) {
      setForm({
        title: editingItem.title,
        type: editingItem.type,
        shortDesc: editingItem.shortDesc,
        detailedDesc: editingItem.detailedDesc,
        date: editingItem.date?.slice(0, 16), // trim seconds
        image: null,
      });
    }
  }, [editingItem]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm({
      ...form,
      [name]: files ? files[0] : value
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const fd = new FormData();
  Object.keys(form).forEach(key => {
    if (form[key] !== null) {
      fd.append(key, form[key]);
    }
  });

  try {
    if (editingItem) {
      await axios.put(`http://localhost:5000/api/news-events/${editingItem.id}`, fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${getToken()}`
        }
      });
    } else {
      await axios.post('http://localhost:5000/api/news-events', fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${getToken()}`
        }
      });
    }

    setForm({ title: '', type: 'News', shortDesc: '', detailedDesc: '', date: '', image: null });
    onItemAdded();
  } catch (err) {
    alert('Failed to submit item');
  }
};
{editingItem && (
  <button type="button" className="btn btn-secondary mt-2 ms-2" onClick={() => setForm({
    title: '', type: 'News', shortDesc: '', detailedDesc: '', date: '', image: null
  })}>
    Cancel Edit
  </button>
)}


  return (
    <form onSubmit={handleSubmit} className="mb-4">
      <h4>Add News or Event</h4>
      <div className="row g-2">
        <div className="col-md-6">
          <input type="text" className="form-control" name="title" placeholder="Title" value={form.title} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <select name="type" className="form-select" value={form.type} onChange={handleChange} required>
            <option value="News">News</option>
            <option value="Event">Event</option>
          </select>
        </div>
      </div>
      <textarea className="form-control mt-2" name="shortDesc" placeholder="Short Description" value={form.shortDesc} onChange={handleChange} required />
      <textarea className="form-control mt-2" name="detailedDesc" placeholder="Detailed Description" value={form.detailedDesc} onChange={handleChange} />
      <input className="form-control mt-2" name="date" type="datetime-local" value={form.date} onChange={handleChange} required />
      <input className="form-control mt-2" name="image" type="file" accept="image/*" onChange={handleChange} required />
      <button className="btn btn-success mt-3">Submit</button>
    </form>
  );
};



export default AdminNewsEventForm;
